/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * When form was completed
 * @export
 * @interface CompletedAt2
 */
export interface CompletedAt2 {
}

/**
 * Check if a given object implements the CompletedAt2 interface.
 */
export function instanceOfCompletedAt2(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompletedAt2FromJSON(json: any): CompletedAt2 {
    return CompletedAt2FromJSONTyped(json, false);
}

export function CompletedAt2FromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedAt2 {
    return json;
}

export function CompletedAt2ToJSON(value?: CompletedAt2 | null): any {
    return value;
}

